// visits
export const GET_VISITS_SUCCESS = 'GET_VISITS_SUCCESS';
export const GET_VISITS_FAILURE = 'GET_VISITS_FAILURE';
export const GET_VISITS_REQUEST = 'GET_VISITS_REQUEST';
export const CLEAR_VISITS = 'CLEAR_VISITS';

// search
export const SET_VISITS_SEARCH = 'SET_VISITS_SEARCH';
export const SET_VISITS_STATUS = 'SET_VISITS_STATUS';
export const SET_VISITS_PAGE_SIZE = 'SET_VISITS_PAGE_SIZE';
export const NEXT_VISITS_PAGE = 'NEXT_VISITS_PAGE';
export const PREV_VISITS_PAGE = 'PREV_VISITS_PAGE';
